import { getCsrfToken } from './bootstrapData';

function delay(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export default async function agFetch(
  input: string,
  init?: RequestInit | undefined,
  retryBackoff?: number,
): Promise<Response> {
  const defaultHeaders: HeadersInit = {
    'x-requested-with': 'XMLHttpRequest', // required so that user is not redirected to API url after session expiry
    'x-csrf-token': await getCsrfToken(),
  };
  const headers: HeadersInit = { ...defaultHeaders, ...init?.headers };

  // Make URL absolute at this point, because passing a relative URL to fetch in Vitest tests (with Node fetch + jsdom) won't work
  const url = input.startsWith('/') && typeof window !== 'undefined' ? `${window.location.origin}${input}` : input;
  const response = await fetch(url, { ...init, ...{ headers } });

  if (retryBackoff != null && response.status >= 500) {
    // eslint-disable-next-line no-console
    console.warn(`temporary response error ${response.status} from ${input}, will retry in ${retryBackoff} ms`);
    await delay(retryBackoff);
    // Try again
    return agFetch(input, init, retryBackoff * 2);
  }

  return response;
}
